import { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';

const AppErrorBoundary = () => {
  const [copied, setCopied] = useState(false);
  const error = useRouteError() as object;

  const getMessage = () => {
    if ('message' in error) {
      return error.message;
    }

    return error;
  };

  const message = String(getMessage());

  const handleClick = () => {
    setCopied(true);

    void navigator.clipboard.writeText(message);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="text-center max-w-md">
        <p className="text-lg font-semibold text-gray-900 mb-2">Something went wrong</p>
        <p className="text-sm text-gray-500 mb-4 break-all">{message}</p>
        <button
          onClick={handleClick}
          className="text-sm text-[#F7931A] hover:underline"
        >
          {copied ? 'Copied!' : 'Copy error'}
        </button>
      </div>
    </div>
  );
};

export default AppErrorBoundary;